import { Opportunity, Population } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { OpportunityPopulationEntityConfig } from "./config";
import { OpportunityPopulationFilters } from "./filters";
import { OpportunityPopulationMethods } from "./methods";

@HyperEntity("opportunity-population", OpportunityPopulationEntityConfig)
export class OpportunityPopulation extends extender(
    OpportunityPopulationFilters,
    OpportunityPopulationMethods,
) {
    @Fields.string({ dbName: "population_id" })
    populationId = "";

    @Fields.string({ dbName: "opportunity_id" })
    opportunityId = "";

    @Relations.toOne(() => Population, "populationId")
    population?: Population;

    @Relations.toOne(() => Opportunity, "opportunityId")
    opportunity?: Opportunity;

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();

    @Fields.updatedAt({ dbName: "updated_at" })
    updatedAt = new Date();
}






